// extracted by mini-css-extract-plugin
export default {"productCardContainer":"ProductTypeSection_productCardContainer__5pqLu","card":"ProductTypeSection_card__MzLwc"};